/* Protech Solutions VB · Cotizador localStorage · WA: +56 9 5215 7964
   v3: No usa el carrito de Shopify — el inventario nunca bloquea agregar. */

const PROTECH = {
  wa: '56952157964',
  waUrl: 'https://wa.me/56952157964',
  KEY: 'protech_quote',

  /* ── STORAGE ── */
  getQuote: function() {
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); }
    catch(e) { return []; }
  },
  saveQuote: function(items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
    this.updateCount();
  },
  clearQuote: function() {
    localStorage.removeItem(this.KEY);
    this.updateCount();
    this.renderDrawer();
    this.renderCartPage();
    this.updPreview();
  },

  /* ── ADD ── */
  addProduct: function(p) {
    var items = this.getQuote();
    var existing = items.find(function(it) {
      return it.id === p.id && it.variant === p.variant;
    });
    if (existing) { existing.qty += (p.qty || 1); }
    else {
      items.push({
        id: p.id, title: p.title, vendor: p.vendor || '',
        price: parseInt(p.price) || 0, image: p.image || '',
        variant: p.variant || '', qty: p.qty || 1
      });
    }
    this.saveQuote(items);
    this.openDrawer();
  },

  /* Botón de tarjeta de producto (lee data-attrs) */
  quickAddBtn: function(btn) {
    var orig = btn.innerHTML;
    this.addProduct({
      id: btn.dataset.id, title: btn.dataset.title,
      vendor: btn.dataset.vendor, price: btn.dataset.price,
      image: btn.dataset.image, variant: btn.dataset.variant, qty: 1
    });
    btn.innerHTML = '&#10003; Agregado!';
    btn.style.background = 'var(--grn)';
    setTimeout(function() { btn.innerHTML = orig; btn.style.background = ''; }, 1400);
  },

  /* Página de producto (usa productVariants + productInfo globales) */
  addFromProductPage: function(form) {
    var vid = (form.querySelector('[name=id]') || {}).value;
    var qtyEl = form.querySelector('[name=quantity]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value) || 1) : 1;
    var variant = null;
    if (window.productVariants) {
      variant = productVariants.find(function(v) { return String(v.id) === String(vid); });
    }
    var info = window.productInfo || {};
    var btn = form.querySelector('.btn-add-quote');
    var orig = btn ? btn.innerHTML : '';
    this.addProduct({
      id: info.id || vid,
      title: info.title || document.title,
      vendor: info.vendor || '',
      price: variant ? variant.price : (info.price || 0),
      image: info.image || '',
      variant: (variant && variant.title !== 'Default Title') ? variant.title : '',
      qty: qty
    });
    if (btn) {
      btn.innerHTML = '&#10003; Agregado a cotizacion!';
      btn.style.background = 'var(--grn)';
      setTimeout(function() { btn.innerHTML = orig; btn.style.background = ''; }, 1600);
    }
  },

  /* ── QTY / COUNT ── */
  changeQty: function(idx, qty) {
    var items = this.getQuote();
    if (idx < 0 || idx >= items.length) return;
    if (qty <= 0) items.splice(idx, 1);
    else items[idx].qty = qty;
    this.saveQuote(items);
    this.renderDrawer();
    this.renderCartPage();
    this.updPreview();
  },

  updateCount: function() {
    var n = this.getQuote().reduce(function(s, it) { return s + it.qty; }, 0);
    document.querySelectorAll('.badge-cnt, #drw-cnt').forEach(function(el) {
      el.textContent = n;
    });
    return n;
  },

  fmtMoney: function(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  },

  /* ── FORM DATA ── */
  getTipo: function() {
    var el = document.querySelector('input[name="cf-tipo"]:checked');
    return el ? el.value : '';
  },
  getFormData: function(prefix) {
    var g = function(id) {
      var el = document.getElementById(id);
      return el ? (el.value || '').trim() : '';
    };
    return {
      nombre: g(prefix + '-nombre'), empresa: g(prefix + '-empresa'),
      email: g(prefix + '-email'), telefono: g(prefix + '-tel'),
      region: (document.getElementById(prefix + '-region') || {}).value || '',
      factura: (document.getElementById(prefix + '-factura') || {}).value || '',
      notas: g(prefix + '-notas'), tipo: this.getTipo()
    };
  },

  /* ── MENSAJE WA ── */
  buildMsg: function(fd, items) {
    var m = 'COTIZACION - Protech Solutions VB\n';
    m += '---------------------------------\n';
    if (fd.nombre) m += 'Nombre: ' + fd.nombre + '\n';
    if (fd.tipo) m += 'Tipo: ' + fd.tipo + '\n';
    if (fd.empresa && fd.tipo !== 'Persona natural') m += 'Empresa: ' + fd.empresa + '\n';
    if (fd.email) m += 'Email: ' + fd.email + '\n';
    if (fd.telefono) m += 'Telefono: ' + fd.telefono + '\n';
    if (fd.region && fd.region !== 'Selecciona') m += 'Region: ' + fd.region + '\n';
    if (fd.factura && fd.factura !== 'No (boleta)') m += 'Factura: ' + fd.factura + '\n';
    m += '\nQUIERO COTIZAR:\n';
    items.forEach(function(it, i) {
      m += (i + 1) + '. ' + it.title;
      if (it.variant) m += ' - ' + it.variant;
      m += ' x' + it.qty + '\n';
      m += '   (Precio ref: ' + PROTECH.fmtMoney(it.price) + ')\n';
    });
    if (fd.notas) m += '\nNotas: ' + fd.notas + '\n';
    m += '\nEnviado desde protechsolutionsvb.com\n';
    m += 'Precios referenciales - sujetos a verificacion de stock.';
    return m;
  },

  updPreview: function() {
    var el = document.getElementById('wa-preview');
    if (!el) return;
    var items = this.getQuote();
    if (items.length === 0) {
      el.textContent = 'Agrega productos desde el catalogo para ver el mensaje...';
      return;
    }
    el.textContent = this.buildMsg(this.getFormData('cf'), items);
  },

  sendQuote: function(prefix) {
    var fd = this.getFormData(prefix || 'cf');
    if (!fd.nombre) {
      var el = document.getElementById((prefix || 'cf') + '-nombre');
      if (el) { el.style.borderColor = '#ef4444'; el.focus(); setTimeout(function() { el.style.borderColor = ''; }, 2500); }
      alert('Por favor ingresa tu nombre.');
      return;
    }
    if (!fd.email && !fd.telefono) {
      alert('Ingresa tu email o telefono para poder contactarte.');
      return;
    }
    var items = this.getQuote();
    if (items.length === 0) {
      alert('Tu cotizacion esta vacia. Agrega productos desde el catalogo.');
      return;
    }
    location.href = this.waUrl + '?text=' + encodeURIComponent(this.buildMsg(fd, items));
  },

  /* ── DRAWER ── */
  openDrawer: function() {
    var ov = document.getElementById('cot-overlay');
    var dr = document.getElementById('cot-drawer');
    if (ov) ov.classList.add('open');
    if (dr) dr.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.renderDrawer();
  },
  closeDrawer: function() {
    var ov = document.getElementById('cot-overlay');
    var dr = document.getElementById('cot-drawer');
    if (ov) ov.classList.remove('open');
    if (dr) dr.classList.remove('open');
    document.body.style.overflow = '';
  },

  renderDrawer: function() {
    var body = document.getElementById('drw-body');
    var foot = document.getElementById('drw-foot');
    if (!body) return;
    var items = this.getQuote();
    this.updateCount();

    if (items.length === 0) {
      body.innerHTML = '<div class="cot-dr-empty">'
        + '<div class="cot-dr-empty-ico">&#128203;</div>'
        + '<h3>Tu cotizacion esta vacia</h3>'
        + '<p>Agrega productos para comenzar.</p>'
        + '<a href="/collections/all" class="btn-cop" onclick="PROTECH.closeDrawer()">Ver catalogo</a></div>';
      if (foot) foot.style.display = 'none';
      return;
    }

    body.innerHTML = items.map(function(it, idx) {
      return '<div class="cot-dr-item">'
        + '<div class="cot-dr-item-img"><img src="' + it.image + '" alt="" loading="lazy"></div>'
        + '<div class="cot-dr-item-info">'
        + '<div class="cot-dr-item-brand">' + it.vendor + '</div>'
        + '<div class="cot-dr-item-name">' + it.title + '</div>'
        + (it.variant ? '<div class="cot-dr-item-meta"><span style="background:var(--cop3);border:1px solid var(--cop4);color:var(--cop);border-radius:5px;padding:2px 8px;font-size:11px">' + it.variant + '</span></div>' : '')
        + '</div>'
        + '<div class="cot-dr-item-right">'
        + '<div class="cot-dr-price">' + PROTECH.fmtMoney(it.price) + '</div>'
        + '<div class="cot-dr-qty">'
        + '<button class="cot-dr-qb" onclick="PROTECH.changeQty(' + idx + ',' + (it.qty - 1) + ')">&#8722;</button>'
        + '<input class="cot-dr-qn" value="' + it.qty + '" readonly>'
        + '<button class="cot-dr-qb" onclick="PROTECH.changeQty(' + idx + ',' + (it.qty + 1) + ')">+</button>'
        + '</div>'
        + '<button class="cot-dr-del2" onclick="PROTECH.changeQty(' + idx + ',0)" title="Eliminar">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>'
        + '</button></div></div>';
    }).join('');

    if (foot) {
      foot.style.display = 'block';
      var waBtn = document.getElementById('drw-wa-btn');
      if (waBtn) {
        var msg = 'Hola, quiero cotizar:\n';
        items.forEach(function(it, i) {
          msg += (i + 1) + '. ' + it.title + (it.variant ? ' - ' + it.variant : '') + ' x' + it.qty + '\n';
        });
        msg += '\nEnviado desde protechsolutionsvb.com';
        waBtn.href = PROTECH.waUrl + '?text=' + encodeURIComponent(msg);
      }
    }
  },

  /* ── PÁGINA COTIZACIÓN (/cart) ── */
  renderCartPage: function() {
    var wrap = document.getElementById('quote-items');
    var emptyEl = document.getElementById('quote-empty');
    var fullEl = document.getElementById('quote-full');
    if (!wrap) return;
    var items = this.getQuote();

    if (items.length === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      if (fullEl) fullEl.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    if (fullEl) fullEl.style.display = '';

    var cnt = document.getElementById('quote-count');
    if (cnt) cnt.textContent = items.length + ' producto' + (items.length !== 1 ? 's' : '');

    wrap.innerHTML = items.map(function(it, idx) {
      return '<div class="cart-item">'
        + '<div class="cart-item-img"><img src="' + it.image + '" alt="" loading="lazy"></div>'
        + '<div class="cart-item-info">'
        + '<div class="cart-item-vendor">' + it.vendor + '</div>'
        + '<div class="cart-item-title">' + it.title + '</div>'
        + (it.variant ? '<div class="cart-item-variant">' + it.variant + '</div>' : '')
        + '</div>'
        + '<div class="cart-item-qty">'
        + '<button class="cqb" onclick="PROTECH.changeQty(' + idx + ',' + (it.qty - 1) + ')">&#8722;</button>'
        + '<input class="cqn" type="number" value="' + it.qty + '" min="1" onchange="PROTECH.changeQty(' + idx + ', parseInt(this.value)||1)">'
        + '<button class="cqb" onclick="PROTECH.changeQty(' + idx + ',' + (it.qty + 1) + ')">+</button>'
        + '</div>'
        + '<div class="cart-item-price">' + PROTECH.fmtMoney(it.price) + '</div>'
        + '<div class="cart-item-del">'
        + '<button class="del-btn" onclick="PROTECH.changeQty(' + idx + ',0)" aria-label="Eliminar">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>'
        + '</button></div></div>';
    }).join('');
  },
};

/* ── DOM READY ── */
document.addEventListener('DOMContentLoaded', function() {
  PROTECH.updateCount();

  document.querySelectorAll('.product-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      PROTECH.addFromProductPage(form);
    });
  });

  var ov = document.getElementById('cot-overlay');
  if (ov) ov.addEventListener('click', function() { PROTECH.closeDrawer(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') PROTECH.closeDrawer();
  });

  PROTECH.renderCartPage();

  var preview = document.getElementById('wa-preview');
  if (preview) {
    PROTECH.updPreview();
    ['cf-nombre','cf-tel','cf-email','cf-empresa','cf-region','cf-factura','cf-notas'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', function() { PROTECH.updPreview(); });
        el.addEventListener('change', function() { PROTECH.updPreview(); });
      }
    });
    document.querySelectorAll('input[name="cf-tipo"]').forEach(function(r) {
      r.addEventListener('change', function() { PROTECH.updPreview(); });
    });
  }
});
